// extracted by mini-css-extract-plugin
export default {"mn-version-control":"index_mn-version-control__HHPAP"};